import { render, staticRenderFns } from "./WizardOverlayContainer.vue?vue&type=template&id=6fabebea&scoped=true"
import script from "./WizardOverlayContainer.vue?vue&type=script&lang=js"
export * from "./WizardOverlayContainer.vue?vue&type=script&lang=js"
import style0 from "./WizardOverlayContainer.vue?vue&type=style&index=0&id=6fabebea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabebea",
  null
  
)

export default component.exports